import React from 'react';
import PrivyIDStatementComponent from '../Component/PrivyIDStatementComponent';

export default function PrivyIDStatementContainer() {
  return <PrivyIDStatementComponent />;
}
